import moment from 'moment';

export const getDemographicsVintage = () => {
  const lastUpdate = moment().subtract(1, 'year');
  return lastUpdate.year() + (lastUpdate.quarter() < 3 ? 'A' : 'B');
};
